/* Guarda Mundo - Product rail (spec 0035)
 * Setas longas com page-scroll: cada clique rola uma "página" (= data-columns
 * itens). Desabilita/oculta as setas quando o trilho não transborda. Progressive
 * enhancement: sem JS o trilho ainda rola por toque/trackpad.
 *
 * Desktop (pointer fino): arrastar com o mouse no viewport rola o trilho.
 * Clique e drag coexistem: capture só após limiar; sem movimento o <a> do
 * card navega (mesmo com hold). Não usa pointer touch — galeria do card no
 * mobile continua com scroll nativo nas fotos (gm-product-card.js).
 */
(function () {
  'use strict';

  // Limiar alto o bastante pra clique/hold no mesmo ponto não virar drag.
  var DRAG_THRESHOLD_PX = 8;
  var canFinePointer =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function pageDistance(track, viewport, cols) {
    var first = track.firstElementChild;
    if (!first) return viewport.clientWidth;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    var itemWidth = first.getBoundingClientRect().width;
    var perPage = (itemWidth + gap) * cols;
    // Nunca rola menos que uma tela cheia (ex.: mobile 2-up).
    return Math.max(perPage, viewport.clientWidth * 0.9);
  }

  function enableMouseDragScroll(viewport) {
    if (!canFinePointer) return;

    // tracking = pointerdown ativo; dragging = já passou do limiar (scroll).
    // setPointerCapture só depois do limiar: capturar no pointerdown engole o
    // click do <a class="gm-card__link"> e a PDP não abre.
    var tracking = false;
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var activePointerId = null;

    function endDrag() {
      if (!tracking) return;
      tracking = false;
      activePointerId = null;
      if (dragging) {
        dragging = false;
        viewport.classList.remove('is-dragging');
      }
      if (moved) {
        viewport.dataset.gmRailDragged = '1';
      }
    }

    viewport.addEventListener('dragstart', function (event) {
      // Evita fantasma de <img> / link nativo atrapalhando o arraste.
      event.preventDefault();
    });

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button, a.gm-product-rail__title-link, .gm-product-rail__controls')) {
        return;
      }

      tracking = true;
      dragging = false;
      moved = false;
      activePointerId = event.pointerId;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!tracking || event.pointerId !== activePointerId) return;

      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < DRAG_THRESHOLD_PX) return;

      if (!moved) {
        moved = true;
        dragging = true;
        // Só após limiar: capture + cursor grabbing + bloqueio de hover/click.
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (_) {
            /* ignore */
          }
        }
      }

      viewport.scrollLeft = startScroll - dx;
      event.preventDefault();
    });

    viewport.addEventListener('pointerup', function (event) {
      if (event.pointerId !== activePointerId) return;
      endDrag();
    });

    viewport.addEventListener('pointercancel', function (event) {
      if (event.pointerId !== activePointerId) return;
      endDrag();
    });

    // Clique após arraste: bloqueia navegação do card (capture).
    // Clique sem arraste (mesmo com hold): deixa o <a> navegar normalmente.
    viewport.addEventListener(
      'click',
      function (event) {
        if (viewport.dataset.gmRailDragged !== '1') return;
        delete viewport.dataset.gmRailDragged;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function init(rail) {
    var viewport = rail.querySelector('[data-gm-rail-viewport]');
    var track = rail.querySelector('[data-gm-rail-track]');
    if (!viewport || !track) return;

    var prev = rail.querySelector('[data-gm-rail-prev]');
    var next = rail.querySelector('[data-gm-rail-next]');
    var colsSetting = parseInt(rail.getAttribute('data-columns'), 10) || 4;

    function effectiveCols() {
      var raw = getComputedStyle(rail).getPropertyValue('--gm-rail-cols').trim();
      var n = parseInt(raw, 10);
      if (Number.isFinite(n) && n > 0) return n;
      if (
        window.matchMedia('(min-width: 750px) and (max-width: 1219.98px)').matches
      ) {
        return Math.min(colsSetting, 3);
      }
      return colsSetting;
    }
    var rafId = null;

    function update() {
      rafId = null;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      rail.classList.toggle('is-scrollable', maxScroll > 1);
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 1;
    }

    function scheduleUpdate() {
      if (rafId === null) rafId = window.requestAnimationFrame(update);
    }

    function scrollByPage(direction) {
      viewport.scrollBy({
        left: direction * pageDistance(track, viewport, effectiveCols()),
        behavior: 'smooth',
      });
    }

    if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
    if (next) next.addEventListener('click', function () { scrollByPage(1); });

    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);

    // Drag só em carrossel desktop (grade não transborda horizontalmente).
    if (rail.classList.contains('gm-product-rail--d-carousel')) {
      enableMouseDragScroll(viewport);
    }

    rail.setAttribute('data-gm-rail-ready', '');
    update();
  }

  function boot() {
    var rails = document.querySelectorAll('[data-gm-product-rail]');
    for (var i = 0; i < rails.length; i++) init(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
